import { useId } from 'react';
import { postSheetOpenerMark } from '@lib/postSheet/postSheetLocation';

/**
 * The mark for an element that opens the Post sheet (TECH-197 FE-4c): `subject` (the post it opens)
 * plus this drawn instance's `useId`, so two copies of one post on a screen carry different marks
 * and focus returns to the one tapped. Spread it with `postSheetOpenerProps` and pass the same mark
 * to `navigateToPost`.
 */
export function usePostSheetOpener(subject: string): string {
  return postSheetOpenerMark(subject, useId());
}
